var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgObTickBox1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#OBTickBox1_svg__clip0_1525_1274)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1DC06F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm4.884-11.116a1.25 1.25 0 00-1.768-1.768L9 11.232 6.884 9.116a1.25 1.25 0 10-1.768 1.768l3 3a1.25 1.25 0 001.768 0l5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm4.884-11.116a1.25 1.25 0 00-1.768-1.768L9 11.232 6.884 9.116a1.25 1.25 0 10-1.768 1.768l3 3a1.25 1.25 0 001.768 0l5-5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "OBTickBox1_svg__clip0_1525_1274"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgObTickBox1;